export default "__VITE_ASSET__dfc42bd0__"